import { InstanceScreen } from 'component/navigation/instance';

export default function AdminPuppetToolsScreen() {
    return <InstanceScreen screenKey='puppetTools' />;
}
